import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapAthleteStatisticsComponent } from './components/bootstrap-athlete-statistics/bootstrap-athlete-statistics.component';

const routes: Routes = [
  {path:'', component:BootstrapAthleteStatisticsComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AthleteStatisticsRoutingModule { }
